import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { App } from './component/app/App';
import './localization/Localization';
import { AppThemeProvider } from './theme/AppThemeProvider';

ReactDOM.render(
  <AppThemeProvider>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </AppThemeProvider>,
  document.getElementById('root')
);
